'use strict';

import productStoreInventory from '../../storeinventory/product';
import util from '../../util';
import addToCart from './addToCart';
import productTile from '../../product-tile';
import availability from './availability';
import howToSection from './howToSection';
import productSet from './productSet';
import recommendations from './recommendations';
import socialShareIcons from './socialShareIcons';
import customModal from '../../modal';
import currentLayout from '../../detect-layout';

import imageRedesign from './redesign/image';
import imageDefault from './image';
import variantRedesign from './redesign/variant';
import variantDefault from './variant';

const image = $('.pdp-redesign').length > 0
    ? imageRedesign
    : imageDefault;

const variant = $('.pdp-redesign').length > 0
    ? variantRedesign
    : variantDefault;

const currLayout = currentLayout.init();
/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
	recommendations.init();
	screenResizeHandler();
}

/**
 * @private
 * @function
 * @description Screen Resize Handler.
 */
function screenResizeHandler() {
	// Store the window width
    var winWidth = $(window).width();

	$(window).on('resize orientationchange', function () {
		// Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();
            
			// Do stuff here
			if($('html').hasClass('ingredient-modal') && $(window).width() < 768) {				
				$('#pdpMain .keyingredients-modal .modal-close').trigger('click');	
			}

			var $recommendationCarousel = $('.recommendation-container .carousel-recommendations');			
			if ($recommendationCarousel.hasClass('slick-initialized')) {
				$recommendationCarousel.slick('destroy');
				recommendations.init();
				$('.carousel-recommendations select').selectmenu();
			} else {
				recommendations.init();
			}
        }
	});
}

function ellipsifySocialContentDesc(str, charlength) {
	if (str.length > charlength) {
		return (str.substring(0, charlength));
	} else {
		return str;
	}
}

var showSocialPostDetailModal = function (target) {
	// render content to modal by url
	var url = util.appendParamToURL($(target).attr('href'), 'format', 'ajax');

	currLayout = currentLayout.init();

	$.ajax({
		url: url,
		dataType: 'html',
		success: function (response) {
			customModal.createCustomModal('social-media-post-detail-modal', '#modal-custom-placeholder');
			$('.social-media-post-detail-modal').find('.modal-body').html(response);
		}
	}).complete(function (data) {
		if (currLayout === 'mobile') {
			if (window.innerHeight > window.innerWidth) {
				$('.social-post-detail-content .post-detail-image').css('height', $('.social-media-post-detail-modal').find('.modal-body').width());
				$('.social-post-detail-content .post-detail-content').css('height', $('.social-media-post-detail-modal').find('.modal-body').height() - $('.social-media-post-detail-modal').find('.modal-body').width());
			}
			if (window.innerHeight < window.innerWidth) {
				$('.social-post-detail-content .post-detail-image').css('height', window.innerHeight * 0.5);
				$('.social-post-detail-content .post-detail-content').css('height', window.innerHeight * 0.3);
			}
		}

		if (currLayout === 'desktop') {
			$('.social-post-detail-content .post-detail-image').css('height', $('.social-post-detail-content .post-detail-image').width());
			$('.social-post-detail-content .post-detail-content').css('height', $('.social-post-detail-content .post-detail-image').width());
		}
		$('.social-post-detail-content .sb-container').scrollBox();
	});
}


/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
	var $pdpMain = $('#pdpMain');

	capitalizeFirstLetters();
	addToCart();
	availability();
	variant();
	image();
	howToSection.init();
	productSet();
	socialShareIcons();
	productTile.init();
	if (SitePreferences.STORE_PICKUP) {
		productStoreInventory.init();
	}

	// Add to Wishlist and Add to Gift Registry links behaviors
	$pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
		var data = util.getQueryStringParams($('.pdpForm').serialize());
		if (data.cartAction) {
			delete data.cartAction;
		}
		var url = util.appendParamsToUrl(this.href, data);
		this.setAttribute('href', url);
	});

	// product options
	$pdpMain.on('change', '.product-options select', function () {
		var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
		var selectedItem = $(this).children().filter(':selected').first();
		salesPrice.text(selectedItem.data('combined'));
	});

	// prevent default behavior of thumbnail link and add this Button
	$pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
		e.preventDefault();
	});

	$('.keyingredients .view-all').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var $fullIngredientList = $('.keyingredients-full');
		var pid = $('#pid').val();
		var masterid = $('.product-number span').data('masterid');
		var params = {
				"pid": pid,
				"masterid": masterid,
				"format": "ajax"
		};
		$.get(util.appendParamsToUrl(Urls.getProductIngredients, params)).done(function (content) {
			customModal.createCustomModal('keyingredients-modal', '#modal-custom-placeholder');

			var ingredientModalSibling = $('.keyingredients-content').parent();

			$('.keyingredients-modal').insertAfter(ingredientModalSibling);
			$('.keyingredients-modal').find('.modal-body').html(content);
			$('.keyingredients-modal .modal-body').scrollBox();
			$('html').addClass('ingredient-modal');
			if($('html').hasClass('ingredient-modal') && $(window).width() < 768) {
				disabledDeviceScroll(true);
			}
		});
	});

	$pdpMain.on('click', '.keyingredients .close, .keyingredients-outer-close, .keyingredients-modal .modal-close-outer, .keyingredients-modal .modal-close', function (e) {
		e.preventDefault();
		$('html').removeClass('ingredient-modal');
		$('.keyingredients-modal, .keyingredients-outer-close').remove();
		if(!$('html').hasClass('ingredient-modal') && $(window).width() < 768) {
			disabledDeviceScroll(false);
		}		
	});

	if ($('.product-set-actions').length) {
		var $productForms = $('.product-set-list').find('form').toArray();
		var pids = $productForms.map(function (formEle) {
			return $(formEle).data('pid');
		}).join(',');

		$.post(util.appendParamsToUrl(Urls.wishlistIsSavedForLater, {
			pid: pids
		}), function (data) {
			if (data === 'false') {
				$('.product-form-actions .product-set-wishlist').removeClass('d-none');
				$('.product-form-actions .remove-product-set-from-wishlist').addClass('d-none');
			} else {
				$('.product-form-actions .product-set-wishlist').addClass('d-none');
				$('.product-form-actions .remove-product-set-from-wishlist').removeClass('d-none');
			}
		});

		$('.remove-product-set-from-wishlist').on('click', function (e) {
			e.preventDefault();

			$.post(util.appendParamsToUrl(Urls.wishlistRemoveAll, {
				pid: pids
			}), function () {
				window.location.href = window.location.href;
			})
		});
	}

	$('.size-chart-link a').on('click', function (e) {
		e.preventDefault();
		dialog.open({
			url: $(e.target).attr('href')
		});
	});

	$('.accordion-toggle').on('click', function (e) {
		e.preventDefault();
		var $toggleFor = $(this).attr('href');
		var $toggleHeight = $('.accordion-toggle').outerHeight();
		var $stickyHeader = $('.sticky-header').outerHeight();
		var totalOffset = $toggleHeight + $stickyHeader;

		if ($(this).hasClass('is-open')) {
			$(this).removeClass('is-open');
			$($toggleFor).removeClass('is-open').slideUp();
			return false;
		} else {
			var accordionToggle = $('.accordion-toggle.is-open');
			var accordionContent = $('.pdp-content-section.is-open');

			$(this).toggleClass('is-open');
			$($toggleFor).toggleClass('is-open').slideDown(function () {
				$('html, body').animate({
					scrollTop: $(this).offset().top - totalOffset
				}, 400);
			});
		}

		if ($(this).attr('id') == 'rec-toggle') {
			$('.carousel-recommendations.slick-slider').slick('refresh');
		}
	});

	/**
	 * @description Social Media integration Section
	 **/
	if ($('.pdp-social-media-section').length > 0) {
		$('.post-descriptor p').each(function () {
			$(this).html(ellipsifySocialContentDesc($(this).html(), 83));
		});

		$('.media-post-slot .copy').each(function () {
			$(this).html(ellipsifySocialContentDesc($(this).html(), 100));
		})

		$(document).on('click', '.js-social-post-detail-link', function (e) {
			e.preventDefault();
			showSocialPostDetailModal($(this));
		});
	}

	$('.product-tile-regimen .product-brand-name-block').on('click touchstart', function () {
		$('.product-tile-regimen').removeClass('product-regimen-device');
	});

	$('.product-tile-regimen .product-image').on('click touchstart', function () {
		$('.product-tile-regimen').removeClass('product-regimen-device');
		$(this).parent().addClass('product-regimen-device');
	});
}

var scrollPosition = 0;
function disabledDeviceScroll(flag) {
	var $body = $('body');
	if(flag) {
		scrollPosition = window.pageYOffset;
		$body.css({
			overflow : 'hidden',
			position : 'fixed',
			top : `-${scrollPosition}px`,
			width : '100%'
		});
	} else {
		$body.removeAttr("style");
		window.scrollTo(0, scrollPosition);
	}
}

function capitalizeFirstLetters() {
	function capFirst(string) {
		return string.trim().charAt(0).toUpperCase() + string.slice(1);
	}

	var swatchAnchors = document.querySelectorAll('.swatchanchor');
	swatchAnchors.forEach(function (element) {
		element.title = capFirst(element.title);
	});
}

var product = {
	initializeEvents: initializeEvents,
	init: function () {
		initializeDom();
		initializeEvents();
	}
};

export default product;